StepHandler = App.loadClass 'grower::handlers/placement/StepHandler'

class exports.ClickableTableHandler extends StepHandler

    inputSel: 'div.spp-clickable-cell'

    customAfterLoadLayout: () ->
        @yArray = @taffyObjects.axes(name: 'Y').first().array


    addValidationRules: () ->
        @validator.registerRule
            selector: '.validate-clickable-cell'
            text: '%s requires input'
            func: (elem) =>
                el = $(elem)
                aspectID = el.attr('data-aspect')

                if @yArray is 'fields'
                    fieldID = el.attr('data-field')
                    group = @getInputEl(field: fieldID, aspect: aspectID)

                else if @yArray is 'y_aspects'
                    group = @getInputEl(aspect: aspectID)

                return ( group.filter('.active').length > 0 )


    getFieldAspect: (fieldID, aspectID) ->
        if @yArray is 'fields'
            selectedOption = @getInputEl(field: fieldID, aspect: aspectID).filter('.active')
        else if @yArray is 'y_aspects'
            selectedOption = @getInputEl(aspect: aspectID).filter('.active')

        optionValue = if selectedOption?.attr('data-value') then parseInt selectedOption.attr('data-value') else null
        optionID = if selectedOption?.attr('data-option')? then parseInt selectedOption.attr('data-option') else null

        if optionID?
            optionName = @taffyObjects.options(id: optionID).select('display_name')[0]
        else if optionValue?
            optionName = @taffyObjects.query_options(id: optionValue).select('display_name')[0]

        retval =
            value: optionValue
            options_id: optionID
            option_name: optionName

        # console.log retval
        return retval


    setFieldAspect: (fieldAspect) ->
        if not fieldAspect.fields_id? or not fieldAspect.aspects_id?
            return

        if fieldAspect.options_id
            if @yArray is 'fields'
                group = @getInputEl
                    field: fieldAspect.fields_id
                    aspect: fieldAspect.aspects_id
                input = @getInputEl
                    field: fieldAspect.fields_id
                    aspect: fieldAspect.aspects_id
                    option: fieldAspect.options_id

            else if @yArray is 'y_aspects'
                group = @getInputEl
                    aspect: fieldAspect.aspects_id
                input = @getInputEl
                    aspect: fieldAspect.aspects_id
                    option: fieldAspect.options_id


        else if fieldAspect.value
            if @yArray is 'fields'
                group = @getInputEl
                    field: fieldAspect.fields_id
                    aspect: fieldAspect.aspects_id
                input = @getInputEl
                    field: fieldAspect.fields_id
                    aspect: fieldAspect.aspects_id
                    value: fieldAspect.value

            else if @yArray is 'y_aspects'
                group = @getInputEl
                    aspect: fieldAspect.aspects_id
                input = @getInputEl
                    aspect: fieldAspect.aspects_id
                    value: fieldAspect.value

        if group? and input?
            group.removeClass('active')
            input.addClass('active')


    afterLoadLayout: (sel, data) ->
        super(sel, data)

        step = this

        # add radio-button-esque click handling
        @getInputEl().on 'click', () ->
            el = $(this)

            if el.is('.disabled')
                return

            if step.yArray is 'fields'
                oldEl = step.getInputEl(
                    field: el.attr('data-field')
                    aspect: el.attr('data-aspect')
                ).filter('.active')
            else if step.yArray is 'y_aspects'
                oldEl = step.getInputEl(
                    aspect: el.attr('data-aspect')
                ).filter('.active')

            # check if the active cell changed
            if oldEl[0] is this
                # if the input isn't required, allow it to be deselected
                if not el.hasClass('validate-clickable-cell')
                    el.removeClass('active')
                    el.trigger('change')
            else
                oldEl.removeClass('active')
                el.addClass('active')

                oldEl.trigger('change')
                el.trigger('change')

        # add fill-down logic to the option headers
        @layoutSelector.find('th[data-aspect]').on 'click', () ->

            if $(this).attr('data-option')?
                if step.yArray is 'fields'
                    step.getInputEl(
                        aspect: $(this).attr('data-aspect')
                        option: $(this).attr('data-option')
                    ).click()
                else if step.yArray is 'y_aspects'
                    step.getInputEl(
                        option: $(this).attr('data-option')
                    ).click()

            else if $(this).attr('data-value')?
                step.getInputEl(
                    aspect: $(this).attr('data-aspect')
                    value: $(this).attr('data-value')
                ).click()
